export const ConsultasSolicitadasData = [
  {
    title: "Test PCR (COVID-19)",
  },
  {
    title: "Atención sin turno",
  },
  {
    title: "Ver mis estudios pasados",
  },
];
